import { TextInput, type TextInputProps } from '@mantine/core'
import classes from './StyledTextInput.module.css'

export function Input({ classNames, ...props }: TextInputProps) {
  return (
    <TextInput
      classNames={{
        root: classes.root,
        input: classes.input,
        ...classNames,
      }}
      {...props}
    />
  )
}
